import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import DoneIcon from '@mui/icons-material/Done'
import CustomCheckboxField from '../_common/_form_fields/CustomCheckboxField'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'

const HomeSubscriptionServiceItem = (props) => {
  const { title, is_mandatory, price, currency, setAdditionalPrice } = props
  const { width } = useWindowDimensions()

  const [serviceChecked, setServiceChecked] = useState(false)

  const checkboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: width >= constants.xlBreakpoint ? 28 : 24,
    },
  }

  const handleChangeServiceChecked = (v) => {
    setServiceChecked(v)

    if (v) {
      setAdditionalPrice(prev => parseFloat(prev) + parseFloat(price))
    } else {
      setAdditionalPrice(prev => parseFloat(prev) - parseFloat(price))
    }
  }

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='flex-start'
      sx={{
        width: '100%',
        marginLeft: width >= constants.mdBreakpoint ? '10%' : '2%',
        fontSize: width >= constants.xlBreakpoint ? '18px' : '16px',
      }}
    >
      <Box>
        {
          is_mandatory ?
          <DoneIcon
            fontSize='large'
            sx={{
              margin: width >= constants.xlBreakpoint ? '7px 20px 0px 0px' : '7px 16px 0px 0px',
            }}
          /> :
          <CustomCheckboxField
            checked={serviceChecked}
            handleChange={handleChangeServiceChecked}
            sx={checkboxStyle}
          />
        }
      </Box>
      <Box sx={{ paddingRight: '20px' }}>
        <Box component='span'>{title.value}</Box>
        {
          !is_mandatory &&
          <>
            <Box component='span'> - {price} </Box>
            <Box component='span' sx={{ textTransform: 'uppercase' }}>{currency}</Box>
          </>
        }      
      </Box>
    </Stack>
  )
}

export default HomeSubscriptionServiceItem